import React from "react";
import {
  Container,
  styled,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import UserForm from "components/UserForm/UserForm";

interface AddUserFormProps {
  roleName: string
  returnEndpoint: string
}

const AddUserForm = ({ roleName, returnEndpoint }: AddUserFormProps) => {
  const navigate = useNavigate();

  const redirect = `/${returnEndpoint}`

  return (
    <StyledContainer>
      <div style={{ width: '100%', height: '100%', background: 'white', boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.12)', borderRadius: 5, padding: 20, paddingLeft: 41, paddingTop: 37 }}>
        <Box sx={{ width: "365px" }}>
          <div style={{ width: '100%', height: '100%', color: '#1A1A1A', fontSize: 28, fontFamily: 'Helvetica Neue LT Std', fontWeight: '300', wordWrap: 'break-word', paddingBottom: 12 }}>Add {roleName}</div>
          <UserForm
            roleName={roleName}
            onSuccess={() => navigate(redirect)}
            onClose={() => navigate(redirect)}
          />
        </Box>
      </div>
    </StyledContainer>
  );
};

export default AddUserForm;

const StyledContainer = styled(Container)({
  marginBottom: 24,
})